import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../fragments/__generated__/PageInfo.generated';
import { PromoCodeFragmentDoc } from '../../fragments/__generated__/PromoCode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PromoCodesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  productSpecifics?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PromoCodesQuery = { promoCodes: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, pk: number, availability: boolean, name: string, description: string, startDate: any, endDate: any | null, value: any, valueType: string, token: string, style: any, conditionsAfterVerification: Array<{ variant: Types.PromoCodeConditionVariantEnum, status: Types.PromoCodeConditionStatusEnum, label: string }>, validCartProducts: Array<{ id: string, name: string }> } }> } };


export const PromoCodesDocument = gql`
    query PromoCodes($first: Int!, $productSpecifics: ID) {
  promoCodes(first: $first, filters: {productSpecifics: $productSpecifics}) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        ...PromoCodeFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${PromoCodeFragmentDoc}`;

/**
 * __usePromoCodesQuery__
 *
 * To run a query within a React component, call `usePromoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      productSpecifics: // value for 'productSpecifics'
 *   },
 * });
 */
export function usePromoCodesQuery(baseOptions: Apollo.QueryHookOptions<PromoCodesQuery, PromoCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodesQuery, PromoCodesQueryVariables>(PromoCodesDocument, options);
      }
export function usePromoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodesQuery, PromoCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodesQuery, PromoCodesQueryVariables>(PromoCodesDocument, options);
        }
export type PromoCodesQueryHookResult = ReturnType<typeof usePromoCodesQuery>;
export type PromoCodesLazyQueryHookResult = ReturnType<typeof usePromoCodesLazyQuery>;
export type PromoCodesQueryResult = Apollo.QueryResult<PromoCodesQuery, PromoCodesQueryVariables>;
export function refetchPromoCodesQuery(variables: PromoCodesQueryVariables) {
      return { query: PromoCodesDocument, variables: variables }
    }